<template>
  <popup :close-action="closeActionClicked" :buttons="buttons" class="savings-challenge-popup">
    <template v-slot:title>
      <div class="title-image">
        <img :src="require('@/assets/challenges/savings.svg')">
      </div>
      <div class="title-text">אתגר <span class="bold">חיסכון זה ביטחון</span> של riseup יצא לדרך!</div>
    </template>
    <template v-slot:content>
      <div class="savings-challenge-content">
        <div>כולנו רוצים לחסוך בצורה נכונה כל חודש, וזה בכלל לא כזה מורכב!</div>
        <div>באתגר החיסכון בקבוצת הפייסבוק שלנו אפשר ללמוד כל מה שצריך כדי להתחיל חיסכון חודשי - איפה לחסוך, כמה לחסוך ולמה לשים לב.️</div>
        <div>יש שם המון מידע, ואפשר לשאול הכל!</div>
      </div>
    </template>
  </popup>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../Segment';

export default {
  name: 'SavingsChallengeIndividualPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  async created() {
    Segment.trackUserInteraction('SavingsChallengeIndividualPopupShown');
  },
  computed: {
    buttons() {
      return [{
        title: 'אני רוצה ללמוד עוד!',
        action: this.openFacebook,
        variant: 'primary',
      }];
    },
  },
  methods: {
    ...mapActions('savingsChallenge', ['setPopupClosed']),
    closeActionClicked() {
      Segment.trackUserInteraction('SavingsChallengeIndividualPopup_CloseButtonClicked');
      this.setPopupClosed();
      this.$emit('close');
    },
    openFacebook() {
      Segment.trackUserInteraction('SavingsChallengeIndividualPopup_TellMeMoreClicked');
      window.open('https://www.facebook.com/groups/riseuptogethergroup', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">

.savings-challenge-popup .title {}

.savings-challenge-popup {
  .title-text {
    text-align: center;
    font-family: SimplerPro;
    line-height: 1.1;
    font-size: 27px;

    .bold {
      font-weight: bold;
    }
  }


  .title-image {
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 26px;
    }
  }
  .savings-challenge-content {
    font-family: SimplerPro;
    line-height: 1.5;
    text-align: center;

    div {
      margin-bottom: 20px;
    }

    div:last-child {
      margin-bottom: 0;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/challenges/SavingsChallengeIndividualPopup.vue